import React from 'react';
import ServerErrorSection from '../../siteBaseSections/ServerErrorSection/ServerErrorSection';

export default function HubServerErrorSection() {
  return <ServerErrorSection hub />;
}
